import { Box, Button, Checkbox, ListItemText, MenuItem, Modal, OutlinedInput, Select, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React from "react";
import returnCityNames from "../asset/js/CityNames";
import "./settings-modern.css";

const AREA_NAMES = [
  "צפון",
  "קרית שמונה והסביבה",
  "חיפה והסביבה",
  "ירושלים והסביבה",
  "נתניה והסביבה",
  "השרון והסביבה",
  "מרכז",
  "שפלה והסביבה",
  "באר שבע והסביבה",
  "דרום",
];

function ChangeServiceArea({ open, admin, handleClose, user, addChangedUser, updatePage }) {
  const cityNames = returnCityNames();
  const chosenAreas = user.area ? user.area.split(",").filter(Boolean) : [];
  const [personName, setPersonName] = React.useState(chosenAreas);

  const cityMap = {
    "צפון": cityNames.southCities,
    "קרית שמונה והסביבה": cityNames.northCities,
    "חיפה והסביבה": cityNames.westCities,
    "ירושלים והסביבה": cityNames.eastCities,
    "נתניה והסביבה": cityNames.eCities,
    "השרון והסביבה": cityNames.fCities,
    "מרכז": cityNames.gCities,
    "שפלה והסביבה": cityNames.hCities,
    "באר שבע והסביבה": cityNames.iCities,
    "דרום": cityNames.jCities,
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setPersonName(typeof value === "string" ? value.split(",") : value);
  };

  const handleSubmit1 = () => {
    const userArea = personName.length ? `${personName.join(",")},` : "";
    const request = admin === "yes"
      ? axios.put(
          `${process.env.React_APP_BACKEND_URL}/api/admin/changearea?id=${user.id}`,
          { area: userArea, id: user.id },
          { headers: { Authorization: `Bearer ${Cookies.get("admintoken")}` } }
        )
      : axios.put(
          `${process.env.React_APP_BACKEND_URL}/api/changearea?id=${user.id}`,
          { area: userArea },
          { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
        );

    request.then(() => {
      handleClose("area");
      if (addChangedUser) addChangedUser("area", userArea);
      if (updatePage) updatePage();
    }).catch((err) => console.log(err));
  };

  return (
    <Modal open={open} onClose={() => handleClose("area")} aria-labelledby="change-area-title">
      <Box className="bidit-settings-modal">
        <Box className="bidit-settings-head">
          <Typography id="change-area-title" className="bidit-settings-title">עדכון אזורי שירות</Typography>
          <Typography className="bidit-settings-subtitle">בחרו את כל האזורים שבהם אתם זמינים לקבלת מכרזים.</Typography>
        </Box>

        <Select
          multiple
          fullWidth
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput />}
          displayEmpty
          renderValue={(selected) => selected.length ? selected.join(", ") : "בחרו אזורי שירות"}
          MenuProps={{
            PaperProps: {
              className: "bidit-modern-area-menu",
              sx: { maxHeight: 430, mt: 1, borderRadius: "16px", boxShadow: "0 16px 40px rgba(20,60,95,.18)" },
            },
          }}
          sx={{
            width: "100%",
            fontFamily: "Assistant",
            borderRadius: "14px",
            backgroundColor: "#fbfdff",
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(25,118,210,.22)" },
          }}
        >
          {AREA_NAMES.map((name) => (
            <MenuItem key={name} value={name} sx={{ alignItems: "flex-start", gap: 1, py: 1.2, fontFamily: "Assistant" }}>
              <Checkbox
                checked={personName.indexOf(name) > -1}
                sx={{
                  p: .4,
                  mt: .1,
                  "& .MuiSvgIcon-root": { fontSize: 23 },
                  "&.Mui-checked": { color: "#1976d2" },
                }}
              />
              <Box sx={{ minWidth: 0 }}>
                <ListItemText
                  primary={name}
                  primaryTypographyProps={{ sx: { fontFamily: "Assistant", fontWeight: 800, color: "#173f62" } }}
                />
                <Typography sx={{ fontFamily: "Assistant", fontSize: 12.5, color: "#7a8c9b", lineHeight: 1.45 }}>
                  {(cityMap[name] || []).join(" · ")}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>

        <Button fullWidth onClick={handleSubmit1} variant="contained" className="bidit-settings-primary" sx={{ mt: 2.5 }}>
          שמירת אזורי השירות
        </Button>
      </Box>
    </Modal>
  );
}

export default ChangeServiceArea;
